import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "uk-padding bg-color-csa pattern-1 mt-9" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = {
  class: "uk-flex uk-flex-center",
  "data-uk-grid": ""
}
const _hoisted_4 = { class: "uk-width-1-1" }
const _hoisted_5 = { class: "impx-hp-booking-form hp2 no-margin" }
const _hoisted_6 = {
  class: "uk-grid-margin-small uk-child-width-1-6@xl uk-child-width-1-6@l uk-child-width-1-6@m uk-child-width-1-3@s",
  "data-uk-grid": ""
}
const _hoisted_7 = { class: "uk-form-controls" }
const _hoisted_8 = { class: "uk-inline" }
const _hoisted_9 = { class: "uk-form-controls" }
const _hoisted_10 = { class: "uk-inline" }
const _hoisted_11 = { class: "uk-form-controls uk-position-relative" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "uk-form-controls uk-position-relative" }
const _hoisted_14 = ["value"]

import {ref, getCurrentInstance, onMounted, reactive} from "vue";
import RoomType from "@/models/RoomType";
import RoomFilter from "@/models/RoomFilter";
import {useStore} from "vuex";
import LoadingSpinner from "@/shared/components/loading/LoadingSpinner.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'BookingSearch',
  setup(__props) {

const { $alert } = getCurrentInstance().appContext.config.globalProperties;
const { $axios } = getCurrentInstance().appContext.config.globalProperties;
const { $endpoint } = getCurrentInstance().appContext.config.globalProperties;
// const emit = defineEmits(['searchData'])
const roomTypeList= ref<RoomType[]>([]);
const store = useStore();
const load = ref(false)
  const searchForm = reactive<RoomFilter>({
    arrival:null,
    departure:null,
    guest:1,
    type_appart:null
  })
onMounted(()=>{
  $axios.get($endpoint.LoadRoomType).then((resp_room:any)=>{
    roomTypeList.value = resp_room.data;
  })
})
const getRoomAvailableAtDate = ()=>{
  $axios.post($endpoint.CheckRoomAvailable,searchForm).then((resp_room:any)=>{
    store.dispatch('room_data/saveRoomFound',resp_room.data.data)
  })
  // console.log(event.data.value)
}
  const sendFilterData = ()=>{
  const date_arrival = new Date(searchForm.arrival)
  const date_departure = new Date(searchForm.departure)
  const date_now = new Date()
    if (searchForm.arrival == null|| searchForm.departure == null
        || (date_arrival >= date_departure)
        || (date_arrival.getDate()  < date_now.getDate())
        || (date_departure < date_now)){
      $alert.fire({
        title: 'Ooops!',
        text: 'Veuillez choisir un intervalle de date correct',
        icon: 'error',
        confirmButtonColor:'#D62F2F',
        confirmButtonText: 'Compris'
      })
    }else {
      load.value = true
      store.dispatch('booking_filter/saveRoomFilterData', searchForm)
      getRoomAvailableAtDate()
      load.value =false
    }
  }
  const resetFilter = ()=>{
    load.value = true
    searchForm.departure =null
    searchForm.arrival =null
    searchForm.guest =1
    searchForm.type_appart=null
    store.dispatch('booking_filter/resetRoomFilterData')
    store.state.room_data.roomAvailableData=[]
    store.dispatch('room_data/loadInitialData')
    setTimeout(()=>{
      load.value =false

    },1000)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (load.value)
        ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "uk-heading-line uk-text-center impx-text-white uk-text-uppercase" }, [
              _createElementVNode("span", null, "Consultez les disponibilités")
            ], -1)),
            _createElementVNode("form", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("label", { class: "uk-form-label" }, "Entrée", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("span", {
                    class: "uk-form-icon",
                    "data-uk-icon": "icon: calendar"
                  }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "uk-input booking-arrival uk-border-rounded",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchForm.arrival) = $event)),
                    type: "date",
                    placeholder: "m/dd/yyyy"
                  }, null, 512), [
                    [_vModelText, searchForm.arrival]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "uk-form-label" }, "Depart", -1)),
                  _cache[9] || (_cache[9] = _createElementVNode("span", {
                    class: "uk-form-icon",
                    "data-uk-icon": "icon: calendar"
                  }, null, -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "uk-input booking-departure uk-border-rounded",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm.departure) = $event)),
                    type: "date",
                    placeholder: "m/dd/yyyy"
                  }, null, 512), [
                    [_vModelText, searchForm.departure]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  class: "uk-form-label",
                  for: "form-guest-select"
                }, "Invités", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("span", {
                  class: "uk-form-icon select-icon",
                  "data-uk-icon": "icon: users"
                }, null, -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "uk-select uk-border-rounded",
                  id: "form-guest-select",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchForm.guest) = $event))
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Veuillez sélectionné le nombre d'occupants", -1)),
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (pers) => {
                    return _createElementVNode("option", {
                      value: pers,
                      key: pers
                    }, _toDisplayString(pers) + " personne(s)", 9, _hoisted_12)
                  }), 64))
                ], 512), [
                  [_vModelSelect, searchForm.guest]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _cache[14] || (_cache[14] = _createElementVNode("label", {
                  class: "uk-form-label",
                  for: "form-rooms-select"
                }, "Type d'appartement", -1)),
                _cache[15] || (_cache[15] = _createElementVNode("span", {
                  class: "uk-form-icon select-icon",
                  "data-uk-icon": "icon: album"
                }, null, -1)),
                _withDirectives(_createElementVNode("select", {
                  class: "uk-select uk-border-rounded",
                  id: "form-rooms-select",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchForm.type_appart) = $event))
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("option", { value: "" }, "Veuillez sélectionné un type d'appart", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roomTypeList.value, (room_type, index) => {
                    return (_openBlock(), _createElementBlock("option", {
                      value: room_type,
                      key: index
                    }, _toDisplayString(room_type.room_type_name), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, searchForm.type_appart]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "uk-form-label empty-label" }, " ", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "uk-button uk-width-1-1",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sendFilterData()))
                }, "Rechercher")
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "uk-button uk-width-1-5@xl uk-width-1-5@l uk-width-1-2@m uk-width-1-1@s",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (resetFilter()))
              }, "Tout les apparts")
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})